var CompanySize = {
	"Company size": "Quy mô công ty",
	"1-19 employees": "1-19 Nhân viên",
	"20-99 employees": "20-99 Nhân viên",
	"100-499 employees": "100-499 Nhân viên",
	"500-999 employees": "500-999 Nhân viên",
	"1,000-9,999 employees": "1.000-9.999 Nhân viên",
	"10,000 employees or more": "10.000 Nhân viên trở lên"
};

export { CompanySize as default };
